export enum ActionTypes {
  SET_SOCIAL_ACCOUNTS = '@invitedListPage/SET_SOCIAL_ACCOUNTS',
}

import { ICampaign } from 'src/common/models/campaign';
import { IOrganization } from 'src/common/models/organization';
import { ISocialAccount } from 'src/common/models/socialAccount';

/**
 * Action.
 */
export interface IInvitedListPageAction {
  type: ActionTypes;
  payload?: {
    count?: number;
    socialAccounts?: ISocialAccount[];
  };
}

/* States */
export interface IInvitedListPage {
  // endpoints
  apiEndpoint: string;
  // brand id and campaign id
  brandId: string;
  campaign: ICampaign;
  org: IOrganization;
  isQa: boolean;

  // social accounts and total count
  count: number;
  socialAccounts: ISocialAccount[];
}

/**
 * Initial state.
 */
export const initialState: IInvitedListPage = {
  apiEndpoint: null,
  brandId: null,
  campaign: null,
  org: null,
  isQa: false,

  count: 0,
  socialAccounts: [],
};
